export const getSegmentName = (segment, brandName, venueId) => {
  if (!segment && !venueId) return `${brandName} Global`;
  return segment;
};
